import Vue from 'vue';
import VLazyImage from 'v-lazy-image/v2/v-lazy-image.es.js';
import { Tabs, Tab } from '@/components';
export default Vue.extend({
    components: {
        Tabs,
        Tab,
        VLazyImage,
    },
    data: () => ({
        activeTab: 0,
        tabs: [
            {
                text: 'Apa Itu Belajar.id',
            },
            {
                text: `Government's Acknowledgement`,
            },
            {
                text: 'Cara Aktivasi',
            },
            {
                text: 'Painpoints',
            },
            {
                text: 'Materi Belajar',
            },
            {
                text: 'Belajar.id vs. Gmail Biasa',
            },
        ],
    }),
    watch: {
        activeTab(val) {
            this.$emit('update:activeTab', val);
        },
    },
});
